import m from "mithril";
const {Sortable} = require("sortablejs")
import Component_Table_Footer from "../../shared/components/component_table_footer";
import Auth from "../../shared/auth";
import Requester from "../../shared/request";
import Toasts from "../../shared/toasts";
import Gateway from "../../shared/app_settings";
import i18n from "../../shared/i18n/i18n";
import ModalManager from "../../shared/modal";
import Modal_Course_New from "./modal_course_new";
import RouterService from "../../shared/services/router.service";
import CategoryTag from "../../shared/components/component_category_tag";
import {categoryTooltipStyle, positionCategoryTooltip} from "../../shared/utilities/category_tooltip";

let loading, filter, search, courses, selected = [],
    categories = [],
    total = 0, limit = 25, offset = 0, orderBy;
let categoryFilter = [];
let categoryDropdownOpen = false;
let categoryDropdownSearch = "";
let categoryTooltip = { courseId: null };
let categoryTooltipTimer = null;

let currentPage = "courses";

function submitPagination(lim, off) {
    limit = lim;
    offset = off;
    loadCourses();
}

function loadCourses() {
    loading = true;
    courses = null;
    selected = [];

    const params = [];
    if (filter) {
        params.push("filter=" + filter);
    }
    if (categoryFilter && categoryFilter.length > 0) {
        categoryFilter.forEach(cat => {
            params.push(`categories=${encodeURIComponent(cat)}`);
        });
    }
    if (search) {
        params.push("search=" + search);
    }
    if (orderBy) {
        params.push("orderBy=" + orderBy);
    }

    params.push("limit=" + limit);
    params.push("offset=" + offset * limit);

    Requester.get(Gateway.admin + "courses" + (params.length > 0 ? "?" + params.join("&") : ""))
        .then(function (result) {
            total = result.properties.totalCount;
            courses = result.entities;
        }).catch(function (error) {
        Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
    }).finally(function () {
        loading = false;
    });
}

function loadCourseCategories() {
    loading = true;
    Requester.get(Gateway.admin + "courses/categories")
        .then(function (result) {
            categories = result.properties.categories;
        }).catch(function (error) {
        Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
    }).finally(function () {
        loading = false;
    });
}

function reorderCourse(id, oldIndex, newIndex) {
    Requester.post(Gateway.admin + "courses/" + id + "/reorder", {id: id, index: newIndex})
        .then(function () {
            Toasts.add("success", i18n.t("saved_changes"), "");
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        });
}

function newCourse() {
    ModalManager.open(i18n.t("create_course"), [], Modal_Course_New);
}

function toggleAllSelected() {
    if (selected.length > 0)
        selected = [];
    else {
        if (courses) {
            for (let i = 0; i < courses.length; i++) {
                selected.push(courses[i].properties.id);
            }
        }
    }
}

function toggleSelected(id) {
    let index = selected.indexOf(id);
    if (index === -1)
        selected.push(id);
    else
        selected.splice(index, 1);
}

function activateCourses() {
    loading = true;
    Requester.post(Gateway.admin + "courses/activate", selected)
        .then(function () {
            loadCourses();
            Toasts.add("success", i18n.t("saved_changes"), "");
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("cant_save"), error.response.properties.detail);
            loading = false;
        });
}

function deactivateCourses() {
    loading = true;
    Requester.post(Gateway.admin + "courses/deactivate", selected)
        .then(function () {
            loadCourses();
            Toasts.add("success", i18n.t("saved_changes"), "");
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("cant_save"), error.response.properties.detail);
            loading = false;
        });
}


function orderByCourseName() {
    if (orderBy === "courseName") {
        orderBy = "courseNameDesc";
    } else if (orderBy === "courseNameDesc") {
        orderBy = null;
    } else {
        orderBy = "courseName";
    }

    loadCourses();
}


const Page_Courses = {

    oninit: function () {
        filter = "active";
        categoryFilter = [];
        loadCourseCategories();
        loadCourses();
        currentPage = "courses";
    },
    view: function () {
        return [
            m(".content-box", [
                m(".toolbar", {class: loading ? "disable-buttons" : ""}, [
                    m(".toolbar-section", [
                        m("h1", i18n.t("courses"))
                    ]),
                    m(".toolbar-section", [
                        Auth.validateRights(["courses_create"], m("button.with-icon btn-cta", {onclick: newCourse}, [m("i.icon-plus"), i18n.t("create_course")]))
                    ])
                ])
            ]),
            m(".content-box", [
                m(".toolbar", {class: loading ? "disable-buttons" : ""}, [
                    m(".toolbar-section", [
                        Auth.validateRights(["courses_edit_settings"], [
                            m(".dropdown", {class: selected.length === 0 ? "disabled" : ""},
                                m("button.with-icon pl-2", [
                                    m("i.icon-visible"),
                                    i18n.t("change_status"),
                                    m("i.icon-back rotate-270 ml-2")
                                ]),
                                m(".dropdown-list", [
                                    m("div", {onclick: activateCourses}, i18n.t("active")),
                                    m("div", {onclick: deactivateCourses}, i18n.t("inactive"))
                                ])
                            ),
                            selected && selected.length > 0 ? m("span.ml-1", [selected.length, i18n.t("space_selected")]) : ""
                        ])
                    ]),
                    m(".toolbar-section", [
                        m(".dropdown", { class: categoryDropdownOpen ? "open" : "" },
                            m(".button.with-icon pl-2 .btn.btn-lg", {
                                onclick: function (e) {
                                    e.stopPropagation();
                                    categoryDropdownOpen = !categoryDropdownOpen;
                                    if (categoryDropdownOpen) categoryDropdownSearch = "";
                                }
                            }, [
                                (function () {
                                    if (categoryFilter && categoryFilter.length > 0) {
                                        if (categoryFilter.length === 1) {
                                            const matched = categories.find(function (c) {
                                                return c.name.toLowerCase() === categoryFilter[0];
                                            });
                                            if (matched) {
                                                return matched.isEditable
                                                    ? m("span", { style: "overflow: hidden; white-space: nowrap; text-overflow: ellipsis; max-width: 150px; display: inline-block; vertical-align: middle;" }, matched.name)
                                                    : i18n.t("category_" + matched.name.toLowerCase().replace(/\s+/g, "_"));
                                            }
                                        }
                                        return categoryFilter.length + " " + i18n.t("selected");
                                    }
                                    return i18n.t("all_types");
                                })(),
                                m("i.icon-back rotate-270 ml-2")
                            ]),
                            categoryDropdownOpen
                            ? m(".dropdown-list", {
                                style: "min-width: 220px;",
                                onclick: function (e) { e.stopPropagation(); },
                                oncreate: function () {
                                    document.addEventListener("click", function closeOnOutside() {
                                        categoryDropdownOpen = false;
                                        m.redraw();
                                        document.removeEventListener("click", closeOnOutside);
                                    });
                                }
                            }, [
                                // Search field inside dropdown
                                m("div", {
                                    style: "padding: 0.4rem 0.5rem; border-bottom: 1px solid var(--border-color, #e5e7eb);",
                                    onclick: function (e) { e.stopPropagation(); }
                                }, [
                                    m("input[type=text]", {
                                        placeholder: i18n.t("search"),
                                        value: categoryDropdownSearch,
                                        oninput: function () { categoryDropdownSearch = this.value; },
                                        onkeydown: function (e) {
                                            if (e.key === "Escape") { categoryDropdownSearch = ""; }
                                            e.stopPropagation();
                                        },
                                        style: "width: 100%; padding: 0.25rem 0.4rem; font-size: 0.875rem; border: 1px solid var(--border-color, #d1d5db); border-radius: 4px;"
                                    })
                                ]),
                                (function () {
                                    const q = categoryDropdownSearch.toLowerCase();
                                    const standard = categories
                                        .filter(function (c) { return !c.isEditable; })
                                        .sort(function (a, b) { return a.name.localeCompare(b.name); });
                                    const custom = categories
                                        .filter(function (c) { return c.isEditable; })
                                        .sort(function (a, b) { return a.name.toLowerCase().localeCompare(b.name.toLowerCase()); });

                                    function matchesSearch(item) {
                                        if (!q) return true;
                                        const label = item.isEditable
                                            ? item.name
                                            : i18n.t("category_" + item.name.toLowerCase().replace(/\s+/g, "_"));
                                        return label.toLowerCase().indexOf(q) !== -1;
                                    }

                                    function renderItem(item) {
                                        // Key is lowercase name WITH spaces — backend matches case-insensitively
                                        const key = item.name.toLowerCase();
                                        const isSelected = categoryFilter.includes(key);
                                        const label = item.isEditable
                                            ? item.name
                                            : i18n.t("category_" + item.name.toLowerCase().replace(/\s+/g, "_"));
                                        return m("div", {
                                            class: isSelected ? "active flex align-top" : "flex align-top",
                                            style: "display: flex; align-items: top;",
                                            onclick: function () {
                                                if (isSelected) {
                                                    categoryFilter = categoryFilter.filter(function (c) { return c !== key; });
                                                } else {
                                                    categoryFilter.push(key);
                                                }
                                                loadCourses();
                                            }
                                        }, [
                                            m("i.my-1 mr-1", {
                                                class: isSelected ? "icon-checkbox-checked" : "icon-checkbox-empty",
                                                style: "flex-shrink: 0; line-height: 1;"
                                            }),
                                            m("span.dropdown-item-label", { title: label }, label)
                                        ]);
                                    }

                                    const filteredStandard = standard.filter(matchesSearch);
                                    const filteredCustom = custom.filter(matchesSearch);
                                    const items = filteredStandard.map(renderItem);

                                    if (filteredCustom.length > 0) {
                                        items.push(m(".dropdown-section-label", {
                                            style: "padding: 0.4rem 0.8rem; font-size: 0.75rem; opacity: 0.6; cursor: default",
                                            onclick: function (e) { e.stopPropagation(); }
                                        }, i18n.t("custom_course_categories")));
                                        filteredCustom.forEach(function (c) { items.push(renderItem(c)); });
                                    }

                                    if (items.length === 0) {
                                        return [m("div", { style: "padding: 0.5rem 0.8rem; font-size: 0.875rem; opacity: 0.6;" }, i18n.t("no_results"))];
                                    }
                                    return items;
                                })()
                            ])
                            : null
                        ),
                        m(".dropdown",
                            m(".button.with-icon pl-2 .btn.btn-lg", [
                                (function () {
                                    if (filter === "active") return i18n.t("active_courses");
                                    if (filter === "inactive") return i18n.t("inactive_courses");
                                    return i18n.t("all_courses");
                                })(),

                                m("i.icon-back rotate-270 ml-2")
                            ]),
                            m(".dropdown-list", [
                                m("div", {
                                    class: !filter && categoryFilter.length === 0 ? "active" : "", onclick: function () {
                                        filter = null;
                                        loadCourses();
                                    }
                                }, i18n.t("all_courses")),
                                m("div", {
                                    class: filter === "active" ? "active" : "", onclick: function () {
                                        filter = "active";
                                        loadCourses();
                                    }
                                }, i18n.t("active_courses")),
                                m("div", {
                                    class: filter === "inactive" ? "active" : "", onclick: function () {
                                        filter = "inactive";
                                        loadCourses();
                                    }
                                }, i18n.t("inactive_courses")),
                            ])
                        ),
                        m(".has-icon-right", [
                            m("input[type=search] .btn.btn-lg", {
                                oninput: function () {
                                    search = this.value;
                                }, onkeyup: function (e) {
                                    if (e.keyCode === 13) {
                                        loadCourses();
                                    }
                                }, value: search, placeholder: i18n.t("search")
                            }),
                            m("i.icon-x c-hand", {
                                onclick: function () {
                                    search = null;
                                    loadCourses();
                                }
                            }),
                            m("i.icon-search c-hand", {
                                onclick: function () {
                                    loadCourses();
                                }
                            })
                        ])
                    ])
                ]),
                m(".flex-column", [
                    !loading ? [
                        courses ? [
                            m(".table-wrapper flex-auto", [
                                courses.length > 0 ? [
                                    m("table.full-width", {class: Auth.validateRights(["courses_edit_settings"]) ? "sortable-table" : ""}, [
                                        m("thead",
                                            m("tr", [
                                                m("th", m(".toolbar-checkbox", {onclick: toggleAllSelected}, m("i", {class: selected.length > 0 ? "icon-checkbox-checked" : "icon-checkbox-empty"}))),
                                                m("th.c-hand", {onclick: orderByCourseName}, [i18n.t("name"), m("i.icon-forward align-middle", {class: orderBy === "courseName" ? "rotate-90" : orderBy === "courseNameDesc" ? "rotate-270" : "rotate-90 translucent"})]),
                                                m("th", i18n.t("course_type")),
                                                m("th", i18n.t("latest_version")),
                                                m("th", i18n.t("active")),
                                                Auth.validateRights(["courses_edit_settings"], m("th", "")),
                                            ])
                                        ),
                                        m("tbody", {
                                            oncreate: Auth.validateRights(["courses_edit_settings"], function (v) {
                                                Sortable.create(v.dom, {
                                                    draggable: "tr",
                                                    handle: ".icon-arrange",
                                                    onEnd: function (e) {
                                                        if (e.oldIndex !== e.newIndex) {
                                                            reorderCourse(e.item.getAttribute("data-id"), e.oldIndex, e.newIndex);
                                                        }
                                                    }
                                                });
                                            })
                                        }, courses.map(function (course) {
                                            return m("tr", {"data-id": course.properties.id}, [
                                                m("td.list-checkbox c-hand pl-1 pr-1", {
                                                    onclick: function () {
                                                        toggleSelected(course.properties.id);
                                                    }, style: "width: 18px;"
                                                }, m("i", {class: selected.indexOf(course.properties.id) !== -1 ? "icon-checkbox-checked" : "icon-checkbox-empty"})),
                                                m("td.text-bolder", m(m.route.Link, {href: RouterService.getCourseUrl(course.properties.id)}, course.properties.name)),
                                                m("td", (function () {
                                                    const cats = course.properties.categories && course.properties.categories.length > 0
                                                        ? course.properties.categories
                                                        : null;
                                                    if (!cats) {
                                                        return m("span.category-tag", i18n.t("category_unassigned"));
                                                    }
                                                    // Sort: standard (non-editable) alpha first, then custom (editable) alpha
                                                    const sorted = cats.slice().sort(function (a, b) {
                                                        if (!!a.isEditable !== !!b.isEditable) return a.isEditable ? 1 : -1;
                                                        return (a.name || "").toLowerCase().localeCompare((b.name || "").toLowerCase());
                                                    });
                                                    function renderTag(cat) {
                                                        if (cat.isEditable) {
                                                            return m(CategoryTag, { class: "category-custom", key: cat.id || cat.name, label: cat.name });
                                                        }
                                                        return m(CategoryTag, {
                                                            class: cat.name ? cat.name.replace(/\s+/g, "-").toLocaleLowerCase() : "",
                                                            key: cat.name,
                                                            label: i18n.t("category_" + (cat.name || "unassigned").replace(/\s+/g, "_").toLocaleLowerCase())
                                                        });
                                                    }
                                                    if (sorted.length <= 3) {
                                                        return sorted.map(renderTag);
                                                    }
                                                    // More than 3: show first 3 + info icon tooltip
                                                    const visible = sorted.slice(0, 3);
                                                    const overflow = sorted.slice(3);
                                                    const courseId = course.properties.id;
                                                    return [
                                                        visible.map(renderTag),
                                                        m("span", { style: "position: relative; display: inline-block; vertical-align: middle; margin-left: 4px;" }, [
                                                            m("span", {
                                                                style: "display: inline-flex; align-items: center; justify-content: center; width: 16px; height: 16px; border-radius: 50%; border: 1.5px solid var(--color-primary, #3b82f6); font-size: 0.65rem; font-weight: 700; color: var(--color-primary, #3b82f6); cursor: help; font-style: italic; line-height: 1;",
                                                                onmouseenter: function (e) {
                                                                    if (categoryTooltipTimer) clearTimeout(categoryTooltipTimer);
                                                                    // Anchor to the icon's viewport position so the tooltip can be
                                                                    // rendered fixed — inside the table it would widen the cell and
                                                                    // add a horizontal scrollbar.
                                                                    const rect = e.currentTarget.getBoundingClientRect();
                                                                    categoryTooltip = { courseId: courseId, rect: rect };
                                                                    m.redraw();
                                                                },
                                                                onmouseleave: function () {
                                                                    categoryTooltipTimer = setTimeout(function () {
                                                                        categoryTooltip = { courseId: null };
                                                                        m.redraw();
                                                                    }, 100);
                                                                }
                                                            }, "i"),
                                                            categoryTooltip.courseId === courseId
                                                                ? m("div", {
                                                                    style: categoryTooltipStyle(categoryTooltip.rect),
                                                                    oncreate: function (vnode) { positionCategoryTooltip(vnode.dom, categoryTooltip.rect); },
                                                                    onupdate: function (vnode) { positionCategoryTooltip(vnode.dom, categoryTooltip.rect); },
                                                                    onmouseenter: function () {
                                                                        if (categoryTooltipTimer) clearTimeout(categoryTooltipTimer);
                                                                    },
                                                                    onmouseleave: function () {
                                                                        categoryTooltip = { courseId: null };
                                                                        m.redraw();
                                                                    }
                                                                }, overflow.map(function (cat) {
                                                                    const text = cat.isEditable
                                                                        ? cat.name
                                                                        : i18n.t("category_" + (cat.name || "unassigned").replace(/\s+/g, "_").toLocaleLowerCase());
                                                                    // Wrap long names onto extra lines instead of truncating —
                                                                    // the tooltip exists to show what the pills couldn't fit.
                                                                    return m("div", { style: "padding: 0.12rem 0; overflow-wrap: break-word;" }, text);
                                                                }))
                                                                : null
                                                        ])
                                                    ];
                                                })()),
                                                m("td", m(m.route.Link, {href: RouterService.getCourseUrl(course.properties.id)}, course.properties.version)),
                                                m("td", m(m.route.Link, {
                                                    href: RouterService.getCourseUrl(course.properties.id),
                                                    tabindex: "-1"
                                                }, course.properties.isActive ? m("i.icon-check") : "")),
                                                Auth.validateRights(["courses_edit_settings"], m("td", m("i.icon-arrange")))
                                            ])
                                        }))
                                    ])
                                ] : m(".text-gray padding", i18n.t("no_courses"))
                            ]),
                            m(Component_Table_Footer, {
                                callback: submitPagination,
                                total: total,
                                limit: limit,
                                offset: offset,
                                loading: loading,
                                item: "courses"
                            })
                        ] : m(".text-gray padding", i18n.t("unable_to_load_courses"))
                    ] : m(".text-gray padding", [i18n.t("loading"), m(".loading-dots")])
                ])
            ])
        ];
    }
};

export default Page_Courses;
